import React from 'react'
import QuickZakat from './quick-zakat'
import QuickFidyah from './quickFidyah'
import Calculator from '../section/calculator/calculator'
import { getAppFlow } from '../views/utils/app.utils'
import { APP_FLOW } from '../common/constant'
import IslamicChatBot from '../views/chatBot'

const SelectedOptions = ({ setHeaderData }) => {
  const selectedOptionType = JSON.parse(localStorage.getItem('selectedOption'))
  const isQuickZakat = (getAppFlow() === APP_FLOW.ZAKAT) && (selectedOptionType?.id == 1)
  const isQuickFidyah = (getAppFlow() === APP_FLOW.FIDYAH) && (selectedOptionType?.id == 1)
  const isZakatWithAi = (getAppFlow() === APP_FLOW.ZAKAT) && (selectedOptionType?.id == 2)
  const isQuickCalculator = (getAppFlow() === APP_FLOW.ZAKAT) && (selectedOptionType?.id == 3)


  return (
    <div className='flow-view'>
      {
        isQuickZakat &&
        <QuickZakat setHeaderData={setHeaderData} />

      }
      {
        isQuickFidyah &&
        <QuickFidyah setHeaderData={setHeaderData} />
      }
      {
        isQuickCalculator &&
         <Calculator setHeaderData={setHeaderData} />
      }
      {
        isZakatWithAi &&
        <IslamicChatBot setHeaderData={setHeaderData} />
      }

    </div>
  )
}

export default SelectedOptions
